import * as React from 'react'
import { SelectSeeker } from 'ui-seeker/core'
import i18n from 'i18n'

const OPTIONS = [
    {label: 'Next month', value: 'nextMonth'},
    {label: 'Next 3 months', value: 'next3Month'},
    {label: 'Next 6 months', value: 'next6Month'},
    {label: 'Next year', value: 'nextYear'},
    {label: 'Custom Date', value: 'custom'}
]

const PREV_OPTIONS = [
    {label: 'Previous Period', value: 'previous'},
    {label: 'Custom Date', value: 'custom'}
]

const DR_KEY = { lastMonth: 'common:dateRange.lastMonth', last3Month: 'common:dateRange.last3Months', last6Month: 'common:dateRange.last6Months', lastYear: 'common:dateRange.lastYear', custom: 'common:dateRange.customDate', previous: 'common:dateRange.previousPeriod', nextMonth: 'common:dateRange.nextMonth', next3Month: 'common:dateRange.next3Months', next6Month: 'common:dateRange.next6Months', nextYear: 'common:dateRange.nextYear', '1month': 'common:dateRange.month1View', '3months': 'common:dateRange.months3View', '6months': 'common:dateRange.months6View', '1year': 'common:dateRange.year1View', month: 'common:dateRange.byMonth', year: 'common:dateRange.byYear', all: 'common:dateRange.allYear' }

export default function SelectLaterRange({previous=false, ...props}) {

    const myProps = {
        label: i18n.t('common:dateRange.nextPeriod'),
        options: !previous ? OPTIONS : PREV_OPTIONS,
        formatOptionLabel: opt => i18n.t(DR_KEY[opt?.value] || '', { defaultValue: opt?.label }),
        isClearable: false, firstSelect: false, isMulti: false,
        icon: {icon: 'calendar'},
        ...props
    }

    return <SelectSeeker {...myProps} />
}